import { render, staticRenderFns } from "./contratos.vue?vue&type=template&id=109753fb"
import script from "./contratos.vue?vue&type=script&lang=js"
export * from "./contratos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports